<template lang="pug">
div.modal-bg(@click="closeModal")
    div.upgrade-upper-master-modal(@click.stop)
        div
            p.mb-0 Masterプランに変更しますか？
            span#modal-close(@click="closeModal")
        div
            p.mb-2 選択した機能はMasterプラン以上でご利用可能です。
            p.mb-2 Masterプランは上限PV数が大幅に増え、<br>多数の高機能を利用でき、高い効果が期待できます。
            a(href="/users/plans") プラン変更はこちら
</template>

<script>
import Vue from "vue";
export default {
    methods: {
        closeModal() {
            this.$emit('close-modal'); // 親コンポーネントへイベントを通知
        },
    },
}
</script>
